/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import PieceEditBody from "ui/feature/piece-edit/PieceEditBody";
import {useParams} from "react-router-dom";
import ContentWrapper from "ui/common/ContentWrapper";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "./PieceEditQuery";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import {PieceEditQuery} from "./__generated__/PieceEditQuery.graphql";

const PieceEdit: React.FC = () => {
    const params = useParams();
    const pieceId = params.piece_id ?? "";
    return (
        <ContentWrapper>
            <QueryRenderer<PieceEditQuery>
                environment={environment}
                query={query}
                variables={{piece_id: pieceId}}
                render={({error, props, retry}) => {
                    if (error) {
                        return <ErrorSection/>;
                    } else if (props) {
                        return <PieceEditBody
                            retry={retry}
                            piece={props.music_viewer.piece}
                        />;
                    } else {
                        return <LoadingSection/>;
                    }
                }}
            />
        </ContentWrapper>
    );
}

export default PieceEdit;